// tslint:disable: max-classes-per-file
import { SelectedPuppetTab } from '@models/puppet.class';
import { Action } from '@ngrx/store';

export enum OperationPuppetTypes {
  SELECT_TAB = '[Operation Puppet] Select Tab',
}

export class SelectTab implements Action {
  readonly type = OperationPuppetTypes.SELECT_TAB;

  constructor(public payload: SelectedPuppetTab) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type OperationPuppetActionsUnion = SelectTab;
